import { useSelector } from 'react-redux';

/**
 * Custom hook that maps a callerId to a videoRoom
 * @param {String|null} callerId - Caller ID
 */
const useSelectedVideoRoom = callerId => {
  if (typeof callerId !== 'string' && callerId !== null) {
    throw new Error('callerId must be a string type');
  }
  const videoRoom = useSelector(state => {
    // TODO: .findLast() is not supported by Edge. need to add a polyfill
    return Object.values(state.videoTo911.rooms).findLast(room => {
      return room.callerId === callerId;
    });
  });

  return videoRoom;
};

export default useSelectedVideoRoom;
